__webpack_require__.p = "https://bmidxbexportplprod.netlify.app/";